import React from 'react';

import LookupStatusBadge from '~components/LookupStatusBadge';

import { GocardlessMandate } from '~direct-debits/models';

interface ComponentProps {
  row: { status: GocardlessMandate['status'] };
}

// Colour-override map mirrors the client-signups badge palette so both tabs
// present a consistent visual identity. The GoCardless API colours are saturated
// originals; these match Bootstrap 5's standard badge shades (TAV-2633).
//
// `submitted` uses bs-info (cyan) rather than bs-warning so it reads as a
// distinct milestone from the two pre-submission pending states — the system
// has done its part and is now waiting on GoCardless to action the mandate.
const COLOUR_OVERRIDES: Record<string, string> = {
  active: '198754',                        // bs-success
  pending_submission: 'FFC107',            // bs-warning
  cancelled: '6c757d',                     // bs-secondary
  pending_customer_approval: 'FFC107',     // bs-warning
  submitted: '0DCAF0',                     // bs-info
  failed: 'DC3545',                        // bs-danger
  expired: '6c757d',                       // bs-secondary
};

// Wide enough to hold the longest label in the mandate-status set
// ("Pending Customer Approval") so all badges in the column render at a
// uniform width regardless of which status the row carries.
const BADGE_MIN_WIDTH = '12rem';

const MandateStatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const overrideColour = COLOUR_OVERRIDES[row.status.tag];
  const resolvedStatus = overrideColour ? { ...row.status, colour: overrideColour } : row.status;
  return (
    <LookupStatusBadge
      status={resolvedStatus}
      dataCy={`dd-mandate-matching-status-${row.status.tag}`}
      style={{ minWidth: BADGE_MIN_WIDTH, display: 'inline-block', textAlign: 'center' }}
    />
  );
};

export default MandateStatusBadge;
